export default __webpack_public_path__ + "static/media/slider-cregar-2.a0a80d92.jpg";